import { Component } from 'react';
import { connect } from 'react-redux';

import { CheckoutLayout, Title, CheckoutInner } from 'common/components/layout';
import { getClubSignupForHostedPayment } from 'redux/clubSignup/actions';

class HostedPayment extends Component {
  componentDidMount() {
    const { props } = this;
    const successFunction = (membership) => {
      props.history.push(`/club/receipt/${membership.id}`);
    };
    const errorFunction = (clubSignup) => {
      props.history.push(`/club/${clubSignup.club.slug}`);
    };
    props.getClubSignupForHostedPayment(successFunction, errorFunction);
  }

  render() {
    const { settings, clubSignup } = this.props;
    if (!settings.data || !clubSignup.data) {
      return (
        <CheckoutLayout title="Club Signup">
          <CheckoutInner>
            <Title>Club Signup</Title>
          </CheckoutInner>
        </CheckoutLayout>
      );
    }
    return (
      <CheckoutLayout title="Club Signup">
        <CheckoutInner settings={settings}>
          <Title>Club Signup</Title>
          The hosted payment provider is still processing the payment. Please
          check back here within the next 30 minutes to see if your signup has
          been processed.
        </CheckoutInner>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting,
  clubSignup: state.clubSignup
});

export default connect(mapStateToProps, { getClubSignupForHostedPayment })(
  HostedPayment
);
